import { Injectable } from '@angular/core';
import { Users } from '@app/shared/interfaces/users.interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private friends: BehaviorSubject<Users> = new BehaviorSubject<Users>(null);

  constructor() {}

  reset() {
    this.friends.next(null);
  }

  setValue(data: any) {
    const target = this.friends;
    target.next(data);
  }

  getSubject() {
    return this.friends;
  }

  getValue() {
    return this.friends.getValue();
  }

  subscribeTo(): Observable<Users> {
    return this.friends.asObservable();
  }
}
